var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.799,
    height: 20.8,
    viewBox: "0 0 20.799 20.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price_icon",
    transform: "translate(-1.414 -2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M10.9,2.1l9.9,1.415,1.414,9.9-9.192,9.192a1,1,0,0,1-1.414,0l-9.9-9.9a1,1,0,0,1,0-1.414Zm2.828,8.486a2,2,0,1,0,0-2.828,2,2,0,0,0,0,2.828Z",
    fill: "#3a99d8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/Price_icon.8d6d3aa61e15ad4072cd4fa22dc7f95c.svg";
export { ForwardRef as ReactComponent };